var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("v-checkbox", {
        staticClass: "grv-input mb-2",
        attrs: {
          "input-value": _vm.value,
          name: _vm.param.name,
          readonly: _vm.readonly,
          color: "primary",
          "hide-details": ""
        },
        on: {
          change: function($event) {
            return _vm.$emit("update:value", $event)
          }
        },
        scopedSlots: _vm._u([
          {
            key: "label",
            fn: function() {
              return [_c("Label", { attrs: { param: _vm.param } })]
            },
            proxy: true
          }
        ])
      }),
      _vm._v(" "),
      _c("Hint", { attrs: { param: _vm.param } })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b03f103c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b03f103c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./build/scramble/app-loader.js!./src/components/fields/boolean.vue
// module id = null
// module chunks = 